import * as yup from 'yup';

export default yup.object({
    username: yup.string().required().max(50).min(10),
    password: yup.string().required().min(10).max(100)
})